const clients = {
  COMPANY: "company" as const,
  BUSINESS: "eservbusiness" as const,
  FIELD: "eserv-field-2" as const,
  QUICKBOOKS: "quickbooks" as const,
} as const;

export default clients;
